import { render, staticRenderFns } from "./ManuscriptSelect.vue?vue&type=template&id=9a085a04&"
import script from "./ManuscriptSelect.vue?vue&type=script&lang=js&"
export * from "./ManuscriptSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports